export default "__VITE_ASSET__DyqwS_I7__"